<div class="radio input input--radio value--{{ value | ftrDasherize }}">
  <input type="radio" [id]="id" class="input__control" [value]="value" [name]="name" [formControl]="control" />
  <label class="input__label" [class.input__label--stress]="!!(summary || summaryTemplate)" [attr.for]="id">
    @if (label) {
      {{ label }}
    }
  </label>
  @if (summary) {
    <span class="input__summary">{{ summary }}</span>
  }
  <ng-container *ngTemplateOutlet="summaryTemplate"></ng-container>
</div>
